import MenuItem from 'antd/es/menu/MenuItem';
import cn from 'classnames';
import React, {useEffect} from 'react';

import {ITableActionProps} from 'components/table/action/table-action-types';
import {loadCustomLinkConfig} from 'features/provide-custom-link/api/thunks';
import {selectCustomLinkConfig} from 'features/provide-custom-link/model/slice';
import {selectContextRawData} from 'modules/context/context-selector';
import {useAppDispatch, useAppSelector} from 'store/config/hooks';
import {selectIsThunkPending, selectThunkError} from 'store/slices/loading-state-slice';

import s from './button-action-custom-link.module.less';
import {InnerCustomLink} from './inner-custom-link';

interface IButtonCustomLinkProps extends ITableActionProps {}

export const ButtonActionCustomLink = ({
    entityName,
    meta,
    wrapper,
    ...props
}: IButtonCustomLinkProps) => {
    const dispatch = useAppDispatch();

    const {
        actionTitle,
        actionIcon,
        referenceUrl,
        actionCode,
    } = meta;

    const referenceKey = referenceUrl && referenceUrl.split('/').pop();
    const linkKey = `${entityName}/${referenceKey}`;

    const linkConfig = useAppSelector(st => selectCustomLinkConfig(st, {key: linkKey}));
    const isLoading = useAppSelector(st => selectIsThunkPending(st, loadCustomLinkConfig.typePrefix));
    const loadingError = useAppSelector(st => selectThunkError(st, loadCustomLinkConfig.typePrefix));
    const {organizationId, taxTypeId} = useAppSelector(selectContextRawData) || {};

    useEffect(() => {
        if (referenceUrl && linkKey) {
            dispatch(loadCustomLinkConfig({key: linkKey, url: referenceUrl}));
        }
    }, [organizationId, taxTypeId]);

    const isSubmenu = !!wrapper;

    const customLinkButton = (
        <InnerCustomLink
            link={linkConfig}
            externalProperties={{
                title: actionTitle,
                icon: actionIcon,
            }}
            isLoading={isLoading}
            loadingError={loadingError?.data}
            actionCode={actionCode}
        />
    );

    return (
        isSubmenu ? (
            <MenuItem
                key={meta.actionTitle}
                className={cn(s['custom-link-meta'], s['submenu-item'])}
                {...props}
            >
                {customLinkButton}
            </MenuItem>
        ) : (
            <div>
                {customLinkButton}
            </div>
        )
    );
};
